export default [
    {
        path: 'billing',
        component: require('@/layouts/content/billing').default,
        name: 'admin.billing',
        redirect: to => {
            return {
                name: 'admin.billing.orders.index'
            }
        },
        children: [
            /** Subscriptions */
            {
                path: 'subscriptions',
                name: 'admin.billing.subscriptions.index',
                component: require('@/views/admin/billing/subscriptions/index').default,
                meta: {
                    auth: {
                        roles: ['manage-orders']
                    }
                }
            },
            {
                path: 'subscriptions/create',
                name: 'admin.billing.subscriptions.create',
                component: require('@/views/admin/billing/subscriptions/form').default,
                meta: {
                    mode: 'create',
                    auth: {
                        roles: ['manage-orders']
                    }
                }
            },
            {
                path: 'subscriptions/:id',
                name: 'admin.billing.subscriptions.edit',
                component: require('@/views/admin/billing/subscriptions/form').default,
                meta: {
                    mode: 'edit',
                    auth: {
                        roles: ['manage-orders']
                    }
                }
            },

            /** Orders */
            {
                path: 'orders',
                name: 'admin.billing.orders.index',
                component: require('@/views/admin/billing/orders/index').default,
                meta: {
                    auth: {
                        roles: ['manage-orders']
                    }
                }
            },
            {
                path: 'orders/create',
                name: 'admin.billing.orders.create',
                component: require('@/views/admin/billing/orders/form').default,
                meta: {
                    mode: 'create',
                    auth: {
                        roles: ['manage-orders']
                    }
                }
            },
            {
                path: 'orders/:id',
                name: 'admin.billing.orders.edit',
                component: require('@/views/admin/billing/orders/form').default,
                meta: {
                    mode: 'edit',
                    auth: {
                        roles: ['manage-orders']
                    }
                }
            },
            {
                path: 'orders/:id/replace',
                name: 'admin.billing.orders.replace',
                component: require('@/views/admin/billing/orders/replace').default,
                meta: {
                    mode: 'edit',
                    auth: {
                        roles: ['manage-orders']
                    }
                }
            },

            /** Rentals */
            {
                path: 'rentals',
                name: 'admin.billing.rentals.index',
                component: require('@/views/admin/billing/rentals/index').default,
                meta: {
                    auth: {
                        roles: ['manage-rentals']
                    }
                }
            },
            {
                path: 'rentals/create',
                name: 'admin.billing.rentals.create',
                component: require('@/views/admin/billing/rentals/form').default,
                meta: {
                    mode: 'create',
                    auth: {
                        roles: ['manage-rentals']
                    }
                }
            },
            {
                path: 'rentals/:id',
                name: 'admin.billing.rentals.edit',
                component: require('@/views/admin/billing/rentals/form').default,
                meta: {
                    mode: 'edit',
                    auth: {
                        roles: ['manage-rentals']
                    }
                }
            },
            {
                path: 'rentals/:id/replace',
                name: 'admin.billing.rentals.replace',
                component: require('@/views/admin/billing/rentals/replace').default,
                meta: {
                    mode: 'edit',
                    auth: {
                        roles: ['manage-rentals']
                    }
                }
            },
            {
                path: 'rentals/:id/renew',
                name: 'admin.billing.rentals.renew',
                component: require('@/views/admin/billing/rentals/renew').default,
                meta: {
                    mode: 'edit',
                    auth: {
                        roles: ['manage-rentals']
                    }
                }
            },

            /** Withdrawals */
            {
                path: 'withdrawal/users/:id',
                name: 'admin.billing.withdrawal.users.form',
                component: require('@/views/admin/billing/withdrawal/form').default,
                meta: {
                    endpoint: '/admin/users',
                    name: 'admin.users',
                    mode: 'edit',
                    type: 'users',
                }
            },
            {
                path: 'withdrawal/funds/:id',
                name: 'admin.billing.withdrawal.funds.form',
                component: require('@/views/admin/billing/withdrawal/form').default,
                meta: {
                    endpoint: '/admin/assets/funds',
                    name: 'admin.assets.funds',
                    mode: 'edit',
                    type: 'funds',
                }
            },
            {
                path: 'withdrawal/accounts/:id',
                name: 'admin.billing.withdrawal.accounts.form',
                component: require('@/views/admin/billing/withdrawal/form').default,
                meta: {
                    endpoint: '/admin/assets/accounts',
                    name: 'admin.assets.accounts',
                    mode: 'edit',
                    type: 'accounts',
                }
            },

            /** Invoices */
            {
                path: 'invoices',
                name: 'admin.billing.invoices.index',
                component: require('@/views/admin/billing/invoices/index').default,
                meta: {
                    auth: {
                        roles: ['manage-invoices']
                    }
                }
            },
            {
                path: 'invoices/:id',
                name: 'admin.billing.invoices.show',
                component: require('@/views/admin/billing/invoices/form').default,
                meta: {
                    mode: 'edit',
                    auth: {
                        roles: ['manage-invoices']
                    }
                }
            },
        ]
    }
]